var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lesson-detail-user" },
    [
      _c(
        "v-list-item",
        { staticClass: "gap-4" },
        [
          _c(
            "v-list-item-avatar",
            {
              staticClass: "cursor-pointer shadow-md",
              on: {
                click: function ($event) {
                  _setup.showContact = true
                },
              },
            },
            [_c("v-img", { attrs: { src: _vm.user.profile_photo_url } })],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item-content",
            [
              _c("v-list-item-subtitle", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c(
                "v-list-item-title",
                { class: { "soli-subtitle": _vm.large } },
                [
                  _c(
                    _setup.Link,
                    { attrs: { href: `/profile/${_vm.user.id}/account` } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.user.name) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-list-item-subtitle", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.user.email) +
                    "\n            "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _setup.showContact
        ? _c(_setup.LessonDetailContact, {
            attrs: {
              title: _vm.user.name,
              contact: _vm.billingUser ?? _vm.user,
            },
            on: {
              reset: function ($event) {
                _setup.showContact = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }